// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1ywn8","col":"styles_col__2xAyj"};